export type TilePickerEscapeAction = "close" | "section-list" | "tile-set-list";

interface TilePickerEscapeState {
  hasSectionView: boolean;
  hasGeneratorView: boolean;
}

export function getTilePickerEscapeAction(
  state: TilePickerEscapeState,
): TilePickerEscapeAction {
  if (state.hasGeneratorView) {
    return "tile-set-list";
  }

  if (state.hasSectionView) {
    return "section-list";
  }

  return "close";
}
